import clsx from 'clsx';
import React from 'react';
import styled from 'styled-components';

const StyledCardContent = styled.div`
  ${p => {
    switch (p.variant) {
      case 'card':
        return `
          padding: 0.75em 1em;
        `;
      case 'root':
        return `
          padding: 0.75em 1em;
        `;
      case 'default':
      default:
        return `
          padding: 0;
        `;
    }
  }}
`;

const CardContent = ({ children, borderBottom, ...props }) => {
  return (
    <StyledCardContent className={clsx({ 'border-b border-gray-100': borderBottom })} {...props}>
      {children}
    </StyledCardContent>
  );
};

export default CardContent;
